module.exports = __webpack_public_path__ + "static/rewardIcon.dc134f61.png";